import PageContainer from "../PageContainer";
import { useData } from "../../../contexts/DataContext/DataContextt";
import { FeatureGroupForm } from "./FeatureGroupForm";
import { useState } from "react";
import { saveFeatureGroup } from "../../../services/featureGroupService";
import { usePreload } from "../../../contexts/DataContext/PreloadContext";
import { featureGroupsPageCache } from "../../../pages/cache/PageCache";

const AddFeatureGroup = () => {
  const { loading } = useData();
  const [saving, setSaving] = useState(false);
  const { showNotification } = usePreload();

  const onSave = async (updatedRow) => {
    if (!updatedRow.featureGroupCode?.trim()) {
      showNotification("Feature group code is required", "error");
      return false;
    }

    try {
      setSaving(true);
      const response = await saveFeatureGroup({ ...updatedRow });
      if (response instanceof Response && !response.ok) {
        throw new Error(`Create feature group failed with status ${response.status}`);
      }

      featureGroupsPageCache.clear();
      showNotification("New feature group was added!", "success");
      return true;
    } catch (error) {
      console.error(error);
      showNotification(
        `Something went wrong when adding ${updatedRow.featureGroupCode} feature group.`,
        "error",
      );
      return false;
    } finally {
      setSaving(false);
    }
  };

  return (
    <PageContainer
      title="Create Feature Group"
      subtitle="Add an ETIM feature group and its localized names"
      breadcrumbs={[
        { title: "ETIM Feature Groups", path: "/featuregroups" },
        { title: "New" },
      ]}
    >
      <FeatureGroupForm
        onSave={onSave}
        props={{
          row: {},
          loading,
          uploading: saving,
          saveText: "Create",
          isUpdate: false,
        }}
      />
    </PageContainer>
  );
};

export default AddFeatureGroup;
